<template>
  <v-app>
    <v-main>
      <div
        @click="drawer = false"
        v-if="drawer"
        class="position-absolute drawer-state"
      ></div>

      <app-bar
        v-if="$route.name != 'Profiles'"
        background="bg-transparent"
        has-bg
        @drawer-toggle="drawer = $event"
        :toggle-active="drawer"
        :navbarFixed="bgDrawer"
        :mainBg="bgMainContent"
        @toggleSettingsDrawer="toggleSettingsDrawer"
      ></app-bar>

      <!-- <div class="px-6 mt-5"></div> -->
      <div class="main-content pt-5 position-relative">
        <div
          class="overlay"
          :class="bgMainContent ? 'bg-main-content' : ''"
          :style="
            bgMainContent
              ? `
          
          height: ${!dashboards.includes($route.name) ? '300px' : '200px'};`
              : ''
          "
        ></div>

        <div
          class="position-card d-flex w-100 justify-space-between align-center py-2 bg-white px-15"
        >
          <div v-for="item in cards" :key="item.name">
            <span @click="choose_card(item)">
              <h3 class="item-nav font-weight-bold text-dark">
                <img
                  width="15"
                  src="@/assets/img/tsleem/click.png"
                  alt="click"
                />
                {{ item.name }}
              </h3>
            </span>
          </div>
        </div>
        <!-- <custom-breadcrumb /> -->
        <div
          :class="`${
            dashboards.includes($route.name)
              ? 'position-pattern-fixed'
              : 'position-pattern'
          }`"
        >
          <img
            class="img-pattern"
            src="@/assets/img/tsleem/pattern.png"
            alt=""
          />
        </div>
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </v-main>
  </v-app>
</template>
<script>
// /* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import { FadeTransition } from "vue2-transitions";
import Drawer from "@/components/Drawer.vue";
import SettingsDrawer from "@/components/Widgets/SettingsDrawer.vue";
import Settings from "@/components/Widgets/Settings.vue";
import CustomBreadcrumb from "@/components/CustomBreadcrumb";
import AppBar from "@/components/AppBar.vue";
export default {
  components: {
    CustomBreadcrumb,
    FadeTransition,
    Drawer,
    SettingsDrawer,
    Settings,
    AppBar,
  },
  data() {
    return {
      dashboards: ["Default", "choose"],
      drawer: null,
      showSettingsDrawer: false,
      sidebarColor: "success",
      sidebarTheme: "transparent",
      navbarFixed: true,
      bgMainContent: false,
      bgDrawer: true,
      platform: null,
      cards: [
        {
          url: this.$baseMenaURL + "api",
          front: this.$frontMenaURL,
          name: " مشعر منى  ",
          type: "mina",
        },
        {
          url: this.$baseArafatURL + "api",
          front: this.$frontArafatURL,
          name: " مشعر عرفات",
          type: "arafat",
        },
        {
          url: this.$baseMozdalifaURL + "api",
          front: this.$frontMozdalifaURL,
          name: " مشعر مزدلفة",
          type: "mozdalifa",
        },
      ],
    };
  },
  methods: {
    choose_card(item) {
      axios.defaults.baseURL = item.url;
      localStorage.setItem("baseUrl", item.url);
      localStorage.setItem("name_systemt", item.name);
      localStorage.setItem("type_system", item.type);
      //   Vue.prototype.frontURL = front;
      this.$router.push("/dashboard");
      // location.reload();
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSettingsDrawer(value) {
      this.showSettingsDrawer = value;
    },
    updateSidebarColor(value) {
      this.sidebarColor = value;
    },
    updateSidebarTheme(value) {
      this.sidebarTheme = value;
    },
    toggleNavbarPosition(value) {
      this.navbarFixed = value;
    },

    toggleMainBackground(value) {
      this.bgMainContent = value;
    },
    toggleSidebarBackground(value) {
      this.bgDrawer = value;
    },
  },
  mounted() {
    // alert(this.$route.name);
    this.initScrollbar();
  },
};
</script>
<style>
.bg-main-content {
  background-image: url("../../assets/img/tsleem/new-bg-login.jpg");
}
.main-content .overlay {
  /* background: linear-gradient(45deg, #be936f, #d6bca6, #d6bca6); */

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
@media print {
  .print {
    /* border: 1px solid black; */
    border: none;
    border-collapse: collapse;
  }
  .print tr > td {
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    font-size: 12px;
  }
  .print tr > th {
    font-size: 14px;
  }

  .print td:first-child {
    border-left: none;
  }

  .print td:last-child {
    border-right: none;
  }

  .print tr > td:last-of-type {
    display: none;
  }
  .print tr > th:last-of-type {
    display: none;
  }
}
.position-card {
  position: fixed;
  top: 59px;
  left: 0;
  right: 0;
  z-index: 3;
}
</style>
